import { useState } from "react";
import { Plus, ChevronDown } from "lucide-react";
import { getFilterCatalog } from "../utils";

/**
 * AddFilterDropdown - Dropdown for adding new filters
 */
export function AddFilterDropdown({ onSelectFilter, existingFilters, isDark }) {
  const [isOpen, setIsOpen] = useState(false);
  const catalog = getFilterCatalog();

  // Filter out already applied filters and filters with no options
  const availableFilters = Object.entries(catalog)
    .filter(([key, data]) => {
      const hasOptions = data.values && Object.keys(data.values).length > 0;
      const notApplied = !existingFilters.includes(key);
      return hasOptions && notApplied;
    })
    .sort((a, b) => a[1].key_label.localeCompare(b[1].key_label, "tr"));

  if (availableFilters.length === 0) return null;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs transition-colors ${
          isDark
            ? "bg-emerald-500/20 text-emerald-400 hover:bg-emerald-500/30"
            : "bg-emerald-500/10 text-emerald-700 hover:bg-emerald-500/20"
        }`}
      >
        <Plus className="h-3 w-3" strokeWidth={2} />
        <span>Filtre Ekle</span>
        <ChevronDown className={`h-3 w-3 transition-transform ${isOpen ? "rotate-180" : ""}`} strokeWidth={2} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown */}
          <div
            className={`absolute top-full left-0 mt-2 z-50 w-64 max-h-64 overflow-auto rounded-xl border shadow-lg ${
              isDark ? "border-white/10" : "border-black/10"
            }`}
            style={{ backgroundColor: isDark ? "#18181b" : "#ffffff" }}
          >
            {availableFilters.map(([key, data]) => (
              <button
                key={key}
                onClick={() => {
                  onSelectFilter(key);
                  setIsOpen(false);
                }}
                className={`w-full text-left px-4 py-2.5 text-sm transition-colors ${
                  isDark ? "hover:bg-white/10 text-white" : "hover:bg-black/5 text-black/80"
                }`}
              >
                {data.key_label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default AddFilterDropdown;
